// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-J":"J_NA_outdoor-recreation-J__tiHTY"};